UploadService.$inject = ['Upload', 'SessionService'];

export function UploadService(Upload, SessionService) {
  var service = {
    uploadFile: uploadFile,
  };

  return service;

  ////////////////

  function uploadFile(
    method,
    url,
    model,
    params,
    cropedImage,
    callbackProgress,
    callbackSuccess,
    callbackError
  ) {
    var additionalParams = {
      audit_company_id: null,
    };

    if (method !== 'get') {
      // What about sudo ??
      if (SessionService.isLoggedIn() && SessionService.getSelectedAccountCompany()) {
        // isLoggedIn to prevent not logged users
        additionalParams.audit_company_id = SessionService.getSelectedAccountCompany().id;
      }
    }

    var data = {};

    if (model) {
      // Single object
      for (var key in params) {
        if (params[key] == null) {
          delete params[key]; // Remove null values
        }
      }

      data[model] = params;
    } else {
      data = params; // check null objects
    }

    var obj = {
      method: method,
      url: url,
      data: data,
      params: additionalParams,
      file: null,
      fileName: null,
    };

    if (cropedImage && cropedImage.file) {
      obj.file = cropedImage.file;
      obj.fileName = Upload.rename(cropedImage.file, cropedImage.fileName);
    }

    return Upload.upload(obj)
      .progress(function (evt) {
        // : any
        // callbackProgress(parseInt((100 * evt.loaded) / evt.total)); // 100.0
        callbackProgress((100 * parseInt(evt.loaded)) / parseInt(evt.total)); // 100.0
      })
      .success(function (response) {
        if (response && response.user_info) {
          var info = SessionService.getCurrentUser();
          info.user_info = response.user_info;

          // Updates cu
          SessionService.setCurrentUser('cu', info);

          // Leave it here as if you use the service call this service again
          var findItemInArray = function (array, key, value) {
            for (var i = 0; i < array.length; i++) {
              if (array[i][key] === value) {
                return array[i];
              }
            }
            return null;
          };

          // var company = SessionService.findCompanyInCompanies(
          //   info.user_info.companies,
          //   'id',
          //   SessionService.getSelectedAccountCompany().id
          // );

          var company = info.user_info.companies.find(
            (company) => company.id === SessionService.getSelectedAccountCompany().id
          );

          SessionService.setSelectedAccountCompany(company, true);
        }

        callbackSuccess(response);
      })
      .error(function (response) {
        callbackError(response);
      });
  }
}
